import Vue from "vue";
const vm = new Vue()

export const getQrCode = async (size , text) => {
    return new Promise((resolve, reject) => {
        vm.$http
            .get(
                vm.$API_URL + "/qrcode" , {
                    headers: {
                        Token: localStorage.getItem("access_token")
                    },
                    params: {
                        size: size,
                        text: text,
                    }
                }
            )
            .then(res => {
                resolve(res.data)
            }).catch(error => {
            })
    })
}